<template>
    <v-container>
        <v-row>
            <v-col cols="12" sm="6" md="4">

                <v-btn color="info" v-on:click="getLeads">Refresh Data</v-btn>&nbsp;
                <v-btn color="info" @click.stop="newLeadDlg = true">New Lead</v-btn>
            </v-col>
        </v-row>        
        <v-dialog v-model="newLeadDlg" persistent max-width="600px">
            <v-form v-model="validForm">
                <v-card>
                    <v-card-title>
                        <span class="headline">User Profile</span>

                    </v-card-title>

                    <v-card-text>
                        <v-row v-if="saveAlert">
                            <v-col cols="12" sm="12" md="12">
                                <v-alert type="success">
                                    Lead saved!!!
                                </v-alert>
                            </v-col>
                        </v-row>
                        <v-container>

                            <v-row>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field label="First name*" :rules="nameRules" v-model="newLeadForm.FirstName" required></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field label="Last name*" :rules="nameRules" v-model="newLeadForm.LastName"
                                                  required></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field label="Email*" :rules="emailRules" v-model="newLeadForm.Email"
                                                  required></v-text-field>
                                </v-col>

                            </v-row>
                        </v-container>
                        <small>*indicates required field</small>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue" :disabled="savingLead" text @click="closeDlg">Close</v-btn>
                        <v-btn color="info" :disabled="!validForm" :loading="savingLead" @click="saveLead">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <v-card>

            <v-data-table :headers="headers"
                          :loading="loadingTable"
                          :items="transactions"
                          :search="search">
                <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                <template slot="item" slot-scope="props">
                    <tr>
                        <td>
                            {{ props.item.leadId }}
                        </td>
                        <td>
                            {{props.item.firstName}}
                        </td>
                        <td>{{props.item.lastName}}</td>
                        <td>{{props.item.email}} </td>

                    </tr>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </v-data-table>
        </v-card>
    </v-container>
</template>

<script>
    export default {
        data: () => ({

            url: process.env.VUE_APP_URL,
            filters: {

            },
             nameRules: [
                v => !!v || 'Name is required',                
              ],
             emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid',
              ],
            newLeadDlg: false,
            
            newLeadForm:
            {
                FirstName: '',
                LastName: '',
                Email: '',
            },
            savingLead: false,
            saveAlert: false,
            validForm:false,
            c: false,
            drawer: null,
            transactions: [],
            search: '',
            loadingTable: false,
            headers: [

                { text: 'LeadId', value: 'leadId' },
                { text: 'First Name', value: 'firstName' },
                { text: 'Last Name', value: 'lastName' },
                { text: 'Email', value: 'email' },

            ],

        }),
        methods:
        {
            closeDlg: function () {
                this.newLeadDlg = false;
                this.getLeads();

            },
           
            saveLead: function () {
                this.savingLead = true;
                var url = process.env.VUE_APP_URL + 'api/leads'
                this.$http.post(url, this.newLeadForm).then(function (response) {

                    var r = response.data;
                    if (r > 0) {
                        
                        this.saveAlert = true;

                    } else {
                        alert('Unable to save lead');
                    }
                    this.savingLead = false;
                },
                    function () {
                        alert('Error loading data');
                        this.savingLead = false;
                    });
            },
            getLeads: function () {

                var url = process.env.VUE_APP_URL + 'api/leads'
                this.loadingTable = true;
                this.$http.get(url).then(function (response) {

                    var r = response.data;
                    this.transactions = r;
                    this.loadingTable = false;

                },
                    function () {
                        alert('Error loading data');
                        this.loadingTable = false;
                    });

            },
            setup: function () {
                this.getLeads();
            }
        },
        mounted: function () {


            this.setup();
        }




    }
</script>
